// This Accordion is for shipping policy and return refund policy used in view_product_details.component.jsx

import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function ProductDetailsAccordion({
  title,
  content,
  isOpen,
  onAccordionClick,
}) {
  return (
    <section>
      <div>
        <div className="my-4">
          <div
            className="flex items-center justify-between md:justify-start gap-2 text-black cursor-pointer"
            onClick={onAccordionClick}
          >
            <motion.p className="text-xs text-black lg:text-sm uppercase">
              {title}
            </motion.p>
            <motion.div className="transform rotate-0 transition-transform duration-300 ease-in-out">
              {isOpen ? (
                <>
                  <span>-</span>
                </>
              ) : (
                <>
                  <span className="text-xs">+</span>
                </>
              )}
            </motion.div>
          </div>

          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{
                  opacity: 1,
                  height: "auto",
                  transition: { duration: 0.3 },
                }}
                exit={{
                  opacity: 0,
                  height: 0,
                  transition: { duration: 0.2 },
                }}
                className="text-gray-500"
              >
                {content}
              </motion.div>
            )}
          </AnimatePresence>
          <div className=""></div>
        </div>
      </div>
    </section>
  );
}
